import { Lightbulb } from "lucide-react";
import type { ReactNode } from "react";
import BizminerLayout from "@/bizminer/layouts/app/BizminerLayout.tsx";
import type {
  BizminerImprovementLever,
  BizminerPillarInsight,
} from "@/types/serializers";
import { ImprovementLeverTabs } from "./ImprovementLeverTabs";

interface ImprovementLeverLayoutProps {
  pillar_insight: BizminerPillarInsight;
  improvement_lever: BizminerImprovementLever;
  current_tab: string;
  children: ReactNode;
}

export default function ImprovementLeverLayout({
  pillar_insight,
  improvement_lever,
  current_tab,
  children,
}: ImprovementLeverLayoutProps) {
  return (
    <BizminerLayout>
      <div className="space-y-6">
        <div className="flex items-center space-x-3">
          <Lightbulb className="h-8 w-8 text-primary" />
          <div>
            <h1 className="text-2xl font-bold text-foreground">
              {improvement_lever.title}
            </h1>
            <p className="text-muted-foreground">
              Journey Stage: {improvement_lever.journey_stage}
            </p>
          </div>
        </div>

        <ImprovementLeverTabs
          currentTab={current_tab}
          pillarInsightId={pillar_insight.id}
          improvementLeverId={improvement_lever.id}
        />

        {children}
      </div>
    </BizminerLayout>
  );
}
